<template>
  <main class="container is-max-desktop" :class='{isFullPage: isFullPage}'>
    <div v-if="reference">
      <Note :note="reference" />
    </div>
    <div class="box mb-6" :class="{ours: ours}">
      <article class="media">
        <div class="media-left">
          <figure class="image is-64x64">
            <img
            class="is-rounded"
            src="https://bulma.io/images/placeholders/128x128.png"
            alt="Image"
            />
          </figure>
        </div>
        <div class="media-content">
          <div class="content">
            <p>
              <a :href="'#/' + pubkey">
                <strong><Name :pubkey="pubkey"/></strong>
              </a>
              <small style='float: right;'>
                <a class='has-text-grey-lighter' :href="'#/n/' + id">
                  <time
                  :datetime="isoDate(created_at)"
                  :title="isoDate(created_at)"
                  >{{ humanDate(created_at) }}</time>
                </a></small>
                <br />
                {{ content }}
              </p>
            </div>
            <nav class="level is-mobile mt-5">
              <div class="level-left">
                <a class="level-item" aria-label="reply">
                  <span class="icon is-small">
                    <i class="fas fa-reply" aria-hidden="true"></i>
                  </span>
                </a>
                <a class="level-item" aria-label="like">
                  <span class="icon is-small">
                    <ion-icon name="heart-outline"></ion-icon>
                  </span>
                </a>
              </div>
            </nav>
          </div>
        </article>
        <div class="reply">
          <button class="button is-small is-primary is-rounded" @click="referencing = !referencing">
            <span>Reply</span>
            <span class="icon">
              <ion-icon name="send"></ion-icon>
            </span>
          </button>
        </div>
        <Publish
          v-if="referencing"
          :reference="id"
          @publish="referencing = false"
          />
          <List v-if="isFullPage" :notes="related" />
        </div>
        <!-- <article class="Note" :class="{ours: ours}">
          <div v-if="reference" class="reference">
            <Note :note="reference" />
          </div>
          <header class="pubkey">
            <a :href="'#/' + pubkey">
              <Name :pubkey="pubkey" />
            </a>
          </header>
          <p>{{ content }}</p>
          <footer>
            <div>
              <em>
                <a :href="'#/n/' + id"
                ><time :datetime="isoDate(created_at)" :title="isoDate(created_at)"
                >{{ humanDate(created_at) }}</time
                ></a
                >
              </em>
            </div>
            <div>
              <a @click="referencing = !referencing">Quote/Reply</a>
            </div>
            <div v-if="ours">
              <div
              class="publish-status"
              v-for="({time, status}, host) in ($store.state.publishStatus[id] || {})"
              >
              {{ host }}: {{ status }} @ {{ humanDate(time) }}
              <button v-if="status == 'failed'" @click="republish">retry</button>
            </div>
          </div>
        </footer>
        <Publish
        v-if="referencing"
        :reference="id"
        @publish="referencing = false"
        />
        <List v-if="isFullPage" :notes="related" />
      </article> -->
  </main>
</template>

<script>
  import prettydate from "pretty-date";

  import { pool } from "./relay";

  export default {
    props: ["note"],
    data() {
      return {
        referencing: false
      };
    },
    computed: {
      isFullPage() {
        return !this.note;
      },
      id() {
        return this.note ? this.note.id : this.$route.params.id;
      },
      event() {
        return (
          this.note || this.$store.state.browsing.get(this.id.slice(0, 5)) || {}
        );
      },
      created_at() {
        return this.event.created_at && new Date(this.event.created_at * 1000);
      },
      content() {
        return this.event.content;
      },
      pubkey() {
        return this.event.pubkey;
      },
      reference() {
        if (this.isFullPage && this.event.ref) {
          return this.$store.state.browsing.get(this.event.ref.slice(0, 5));
        }
      },
      related() {
        var rel = [];
        if (this.isFullPage) {
          for (let k of this.$store.state.browsing.keys()) {
            if (k.slice(0, 10) == "rel:" + this.id.slice(0, 5) + ":") {
              rel.push(this.$store.state.browsing.get(k));
            }
          }
        }
        return rel;
      },
      ours() {
        return this.pubkey === this.$store.getters.pubKeyHex;
      }
    },
    methods: {
      isoDate(d) {
        if (typeof d === "number") d = new Date(d * 1000);
        return d && d.toISOString();
      },
      humanDate(d) {
        if (typeof d === "number") d = new Date(d * 1000);
        return d && prettydate.format(d);
      },
      republish(e) {
        e.preventDefault();
        pool.publish(this.note);
      }
    },
    mounted() {
      if (!this.note) {
        pool.reqEvent({ id: this.$route.params.id });
      }
    }
  };
</script>

<style scoped>
  main {
    margin-top: 4rem;
    width: 90%;
  }
  .isFullPage {
    min-height: 100vh;
  }
  .image img {
    position: absolute;
    top: -2.5rem;
    left: -2rem;
    box-shadow: 0 0.5em 1em -0.125em rgba(0, 0, 0, 0.1),
      0 0px 0 1px rgba(0, 0, 0, 0.02);
  }

  .reply {
    position: relative;
  }
  .reply button {
    position: absolute;
    right: 0;
    bottom: -2.5rem;
    border: none;
    box-shadow: 0 0.5em 1em -0.125em rgba(0, 0, 0, 0.1),
      0 0px 0 1px rgba(0, 0, 0, 0.02);
    text-transform: uppercase;
  }
  /* .Note {
    padding: 5px 10px;
    margin: 5px 0;
    border: 2px dotted;
  }
  .Note.ours {
    background-color: orange;
  }
  .Note p {
    margin: 0;
    padding-left: 20px;
  }
  .Note .reference {
    background-color: lightblue;
  }
  .Note .publish-status {
    font-size: 0.5em;
  }
  .Note footer {
    display: flex;
  }
  .Note footer > * {
    margin: 0 10px;
  } */
</style>
